import { Popover, PopoverContent, PopoverTrigger } from '@radix-ui/react-popover';
import { useState } from 'react';
import Combobox from '@/components/Combobox';
import Icon from '@/components/Icon/Icon';
import { Button } from '@/components/ui/button';
import type { WorkerType } from '@/constants/workerType';
import useValueToLabelCache from '@/hooks/useValueToLabelCache';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useWorkerTypes } from '@/routes/_staff/person/-hooks/useWorkerType';
interface WorkerTypeComboboxProps {
  workerType: WorkerType;
  workerTypeId?: string;
  workerTypeName?: string;
  setWorkerType: (id: string, name: string) => void;
  disabled?: boolean;
}
export const WorkerTypeCombobox = ({
  workerType,
  workerTypeId,
  workerTypeName,
  setWorkerType,
  disabled
}: WorkerTypeComboboxProps) => {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.person.profile.ContractSections.ContractDataSection'
  });
  const [searchText, setSearchText] = useState('');
  const [selectorOpen, setSelectorOpen] = useState(false);
  const valueToLabelCache = useValueToLabelCache();
  const {
    workerTypes: options = [],
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    error
  } = useWorkerTypes(workerType, searchText);
  const handleValueChange = (value: string | null) => {
    const selectedItem = options.find(option => option.id === value);
    if (selectedItem == null) {
      return;
    }
    setWorkerType(selectedItem.id, selectedItem.label);
    setSearchText('');
    setSelectorOpen(false);
  };
  if (error) return <p>{error.message}</p>;
  return <Popover open={selectorOpen} onOpenChange={setSelectorOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="justify-between w-[200px] overflow-hidden text-ellipsis" disabled={isLoading || disabled}>
          {workerTypeName || (isLoading ? '' : t('selectWorkerType'))}
          <Icon iconName="ChevronDownIcon" colorVariant="muted" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-full p-0 z-50" align="end" side="bottom" sideOffset={5}>
        <Combobox type="single" value={workerTypeId ?? null} options={options} isFetching={isLoading || isFetchingNextPage} onSearchChange={setSearchText} search={searchText} searchPlaceholder={t('searchWorkerTypeName')} onValueChange={handleValueChange} valueToLabelCache={valueToLabelCache} selectionDisplayStyle="hidden" onScrollToEnd={fetchNextPage} />
      </PopoverContent>
    </Popover>;
};